import Page from '../../classes/Page';
import carouselData from '../../../modules/carouselData/newsSingle';

const newsSinglePage = new Page({
	name: 'news-single',
	rootElementId: 'js-news-single-page',
	carousels: carouselData
});

export default newsSinglePage;
